import { z } from 'zod';
import { refineRemitRequiredWhenDistinct } from '../address/refine-remit-required-when-distinct.js';
import { vendorAddressPairLocationFields } from './pair-location-fields.js';
/** New Vendor's address pair, held to the vendor Add Address dialog's rules; the vendor's own name is the address name, so it isn't sent again. */
export const createVendorAddressPairInputSchema = z
    .object(vendorAddressPairLocationFields)
    .superRefine(refineRemitRequiredWhenDistinct);
//# sourceMappingURL=create-address-pair-input.js.map